"use client";
import { useEffect } from "react";

import { useServices } from "@src/context/ServicesProvider";
import { addScriptToBody } from "@src/utils/domUtils";

export const TrackingScripts = () => {
  const { publicConfig } = useServices();
  const isProduction = publicConfig.NEXT_PUBLIC_NODE_ENV === "production";

  useEffect(() => {
    const shouldShowTracking = publicConfig.NEXT_PUBLIC_TRACKING_ENABLED;

    if (isProduction && shouldShowTracking) {
      // Google Tag Manager
      addScriptToBody({
        id: "gtm",
        type: "text/javascript",
        innerHTML: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${publicConfig.NEXT_PUBLIC_GTM_ID}');
        `
      });

      // GTM noscript fallback
      const gtmNoscript = document.createElement("noscript");
      const gtmIframe = document.createElement("iframe");
      gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${publicConfig.NEXT_PUBLIC_GTM_ID}`;
      gtmIframe.height = "0";
      gtmIframe.width = "0";
      gtmIframe.style.display = "none";
      gtmIframe.style.visibility = "hidden";
      gtmNoscript.appendChild(gtmIframe);
      document.body.appendChild(gtmNoscript);
    }

    // Removed third-party Growth Channel retargeting pixels (hardcoded Akash pixel IDs).
    // Junoa Network does not ship these trackers. Reintroduce only behind a
    // configured, brand-owned pixel if/when needed.
    // TODO: move to SITE_CONFIG if a Junoa-owned retargeting pixel is added.
  }, [isProduction]);

  return null;
};
